module.exports = __webpack_public_path__ + "img/credentials.a2f55076.svg";